import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FieldsetComponent} from './fieldset.component';
import {FaIconLibrary, FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {faCaretRight} from '@fortawesome/pro-solid-svg-icons';
import {ExpanderComponent} from '@paperlessio/sdk/components/expander';

@NgModule({
  declarations: [FieldsetComponent],
  exports: [
    FieldsetComponent
  ],
  imports: [
    CommonModule,
    FontAwesomeModule,
    ExpanderComponent
  ]
})
export class FieldsetModule {
  constructor(library: FaIconLibrary) {
    library.addIcons(faCaretRight)
  }
}
